import { useTranslation } from 'react-i18next';

import { EmptyDataMessage } from '@/ui';

import { IncidentListComponent } from '@/features/shared/IncidentListComponent';
import { IncidentListLoadingPlaceholder } from '@/features/shared/IncidentListLoadingPlaceholder';
import { toRowFromArchivedIncident } from '@/features/shared/incidentListRow';

import type { IncidentListItem } from './incidentsApi';

export type IncidentArchivePageListProps = {
  incidents: IncidentListItem[];
  isLoading: boolean;
};

export function IncidentArchivePageList({ incidents, isLoading }: IncidentArchivePageListProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return <IncidentListLoadingPlaceholder />;
  }

  if (incidents.length === 0) {
    return <EmptyDataMessage text={t('IncidentArchive_IncidentList_NoIncidentsFound')} />;
  }

  return (
    <>
      <div className="container">
        <div className="row align-items-end bg-light rounded-3 p-1 mb-2">
          <div className="col-3 text-center">
            <div className="x-small">{t('IncidentArchive_Sum_Total')}</div>
            <div className="fs-4">{incidents.length}</div>
          </div>

          <div className="col-3 text-center">
            <div className="x-small">{t('IncidentArchive_Sum_Portal')}</div>
            <div className="fs-4">{incidents.filter((x) => x.appType === 'Web').length}</div>
          </div>

          <div className="col-3 text-center">
            <div className="x-small">{t('IncidentArchive_Sum_App')}</div>
            <div className="fs-4">{incidents.filter((x) => x.appType === 'Mobile').length}</div>
          </div>

          <div className="col-3 text-center">
            <div className="x-small">{t('IncidentArchive_Sum_WithVideo')}</div>
            <div className="fs-4">{incidents.filter((x) => x.videoWasActivated === true).length}</div>
          </div>
        </div>
      </div>

      <IncidentListComponent incidents={incidents.map(toRowFromArchivedIncident)} />
    </>
  );
}
